import { Form, Input } from "antd";
import { useEffect, useState } from "react";
import { Label } from "core/interfaces/components";
import IPasswordForm from "components/PasswordForm/IPasswordForm";
import { validatePassword } from "utils/Validate";
import { GeneralRepository } from "core/data";
import { performAsyncFunction } from "utils/AsyncFunctionUtility";
import { Enhanced } from "utils/ReactUtils";

const PasswordForm: React.FC<IPasswordForm> = ({ mail ,oldPassword,t,handleError}) => {
	const [passwordConfirm, setPasswordConfirm] = useState<string | undefined>(undefined);
	const [password, setPassword] = useState<string | undefined>(undefined);
	const [passwordMinLenght, setPasswordMinLenght] = useState<string>("");

	const validateConfirmPassword = async (rule: any, value: any, callback: any, text: string) => {
		let match = password === passwordConfirm;

		if (!match) {
			await Promise.reject(text);
		}

		await Promise.resolve(value);
	};
	const validatePasswordvsMail = async (rule: any, value: any, callback: any, text: string) => {
		if (mail) {
			if (mail === value) await Promise.reject(text);
		}

		await Promise.resolve(value);
	};


	const validatePasswordvsOldPw = async (rule: any, value: any, callback: any, text: string) => {
		if (oldPassword) {
			if (oldPassword === value) await Promise.reject(text);
		}

		await Promise.resolve(value);
	};

	useEffect(() => {
		performAsyncFunction(async () => {
			if (!passwordMinLenght || passwordMinLenght === "") {
				let minLenght = await GeneralRepository.passwordMinLenghtGet();
				setPasswordMinLenght(minLenght);
			}
		}, handleError);
	}, [handleError, passwordMinLenght]);

	return (
		<>
			<div>
				<Label text={t("changePassword.form.password").replace("<%NumeroCaratteri%>", passwordMinLenght)} />
				<div>
					<Form.Item
						name="Password"
						rules={[
							{ required: true, message: t("login.messagges.password") },
							{
								validator: (rule: any, value: any, callback: any) =>
									validatePassword(
										rule,
										value,
										callback,
										t("register.validationMessages.password").replace("<%NumeroCaratteri%>", passwordMinLenght)
									),
							},
							{
								validator: (rule: any, value: any, callback: any) =>
									validatePasswordvsMail(rule, value, callback, t("register.validationMessages.PasswordvsMail")),
							},
							{
								validator: (rule: any, value: any, callback: any) =>
									validatePasswordvsOldPw(rule, value, callback, t("register.validationMessages.PasswordvsOldPw")),
							},
						]}
					>
						<Input.Password size="middle" onChange={(e) => setPassword(e.target.value)} />
					</Form.Item>
				</div>
			</div>
			<div>
				<Label text={t("changePassword.form.confirmPassword")} />
				<div>
					<Form.Item
						name="ConfirmPassword"
						rules={[
							{ required: true, message: t("register.requiredMessages.confirmPassword") },
							{
								validator: (rule: any, value: any, callback: any) =>
									validateConfirmPassword(rule, value, callback, t("register.validationMessages.ConfirmPassword")),
							},
							{
								validator: (rule: any, value: any, callback: any) =>
									validatePassword(
										rule,
										value,
										callback,
										t("register.validationMessages.password").replace("<%NumeroCaratteri%>", passwordMinLenght)
									),
							},
							{
								validator: (rule: any, value: any, callback: any) =>
									validatePasswordvsMail(rule, value, callback, t("register.validationMessages.PasswordvsMail")),
							},
						]}
					>
						<Input.Password size="middle" onChange={(e) => setPasswordConfirm(e.target.value)} />
					</Form.Item>
				</div>
			</div>
		</>
	);
};

export default Enhanced( PasswordForm,{componentNamespace:"PasswordForm"});
